import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { getControl } from '@shared/helpers/form.helper';
import { Utilities } from '@core/helpers/utilities';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { MyVerbale } from '../../../models/interfaces/revisione.interface';
import { numToStr } from '@shared/helpers/math.helper';
import { debounceTime, merge, startWith } from 'rxjs';
import { DatiBilancioBisHelpers } from '../../../../features/dati-bilancio-bis/models/helpers/dati-bilancio-bis.helpers';
import { getContribLegge59Control } from '../validators/helpers/contrib-legge-59-92-form.helpers';
import { cloneDeep } from 'lodash-es';
import { formPaths } from '@shared/constants/form-paths.const';

export const setContribLegge59PerditeBilancioListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    const flags = [false, true];
    flags.forEach((isAnno2) => {
        my_PerditeEsercCalcolatoHelper(form, store, isAnno2);
    });
};

/** isAnno2=true → suffisso "2"/esercizio corrente, campo `my_PerditeEserc_calcolato` (senza suffisso "Anno1").
 * isAnno2=false → suffisso "1"/esercizio precedente, campo `my_PerditeEsercAnno1_calcolato`. */
const my_PerditeEsercCalcolatoHelper = (form: FormGroup, store: Store<Revisione53State>, isAnno2: boolean): void => {
    const suffix = isAnno2 ? '2' : '1';
    const anno = isAnno2 ? 'anno2' : 'anno1';
    const calcolatoFieldName = isAnno2 ? 'my_PerditeEserc_calcolato' : 'my_PerditeEsercAnno1_calcolato';
    const passivo = `${formPaths.datiBilancio}.my_StatoPatrimoniale__Passivo`;

    const aII = getControl(form, `${passivo}.my_StPaPsAII${suffix}`);
    const aIII = getControl(form, `${passivo}.my_StPaPsAIII${suffix}`);
    const aIV = getControl(form, `${passivo}.my_StPaPsAIV${suffix}`);
    const aV = getControl(form, `${passivo}.my_StPaPsAV${suffix}`);
    const aVI = getControl(form, `${passivo}.my_StPaPsAVI${suffix}`);
    const aVIItot = getControl(form, `${passivo}.my_StPaPsAVIItot${suffix}`);
    const aVIII = getControl(form, `${passivo}.my_StPaPsAVIII${suffix}`);
    const aVII_new = getControl(form, `${passivo}.my_StPaPsAVII_new${suffix}`);
    const aX = getControl(form, `${passivo}.my_StPaPsAX${suffix}`);
    const tipoSchema = getControl(form, `${formPaths.datiBilancio}.my_TipoSchemaBil${suffix}`);

    const calcolatoControl = getContribLegge59Control(form, calcolatoFieldName);

    merge(
        aII.valueChanges.pipe(startWith(aII?.value ?? null)),
        aIII.valueChanges.pipe(startWith(aIII?.value ?? null)),
        aIV.valueChanges.pipe(startWith(aIV?.value ?? null)),
        aV.valueChanges.pipe(startWith(aV?.value ?? null)),
        aVI.valueChanges.pipe(startWith(aVI?.value ?? null)),
        aVIItot.valueChanges.pipe(startWith(aVIItot?.value ?? null)),
        aVIII.valueChanges.pipe(startWith(aVIII?.value ?? null)),
        aVII_new.valueChanges.pipe(startWith(aVII_new?.value ?? null)),
        aX.valueChanges.pipe(startWith(aX?.value ?? null)),
        tipoSchema.valueChanges.pipe(startWith(tipoSchema?.value ?? null))
    )
        .pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME))
        .subscribe(() => {
            updateVerbaleOnStore(store, (myVerbale) => {
                const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
                const calcolatoStr = numToStr(DatiBilancioBisHelpers.calcolaPerditeEsercizio(form, anno));
                calcolatoControl.patchValue(calcolatoStr, { emitEvent: false });
                myVerbaleClone.my_SezioneI__Rilevazione.my_ContributoLegge59[calcolatoFieldName] = calcolatoStr;
                return myVerbaleClone;
            });
        });
};
